import 'abortcontroller-polyfill/dist/abortcontroller-polyfill-only';
import { get, post } from '../Services/http';

export const VARIANT_PICKER_RECEIVE = "VARIANT_PICKER_RECEIVE";
export const VARIANT_PICKER_GET = "VARIANT_PICKER_GET";
export const VARIANT_PICKER_GET_VARIANT_URL = "VARIANT_PICKER_GET_VARIANT_URL";
export const VARIANT_PICKER_RECEIVE_VARIANT_URL = "VARIANT_PICKER_RECEIVE_VARIANT_URL";
export const VARIANT_PICKER_ERROR = "VARIANT_PICKER_ERROR";

let abortController;

export const getVariantPickerData = currentVariantId => (dispatch) => {
    return get('/api/variantpicker?currentVariantId='+currentVariantId)
        .then(response => response.json())
        .then(result => dispatch(receiveVariantPickerData(result)))
        .catch(err => dispatch(onError(err)))
}

export const getVariantUrl = (currentVariantId, fieldValues) => (dispatch) => {
    // abort any existing, pending request.
    // It's ok to call .abort() after the fetch has already completed, fetch simply ignores it.
    abortController && abortController.abort();
    abortController = new AbortController();

    return post("/api/variantpicker/" + currentVariantId, fieldValues, abortController)
    .then(res => res.json())
    .then(url => dispatch(receiveVariantUrl(url)))
    .catch(err => dispatch(onError(err)))
}

export const receiveVariantPickerData = data => ({
    type: VARIANT_PICKER_RECEIVE,
    payload: {
        variantPickerData: data
    }
})

export const receiveVariantUrl = url => ({
    type: VARIANT_PICKER_RECEIVE_VARIANT_URL,
    payload: {
        variantUrl: url
    }
})

export const onError = error => ({
    type: VARIANT_PICKER_ERROR,
    payload: {
        error
    }
})